export enum Modulo {
  CADASTROS = 'Cadastros',
  CRM = 'CRM',
  USUARIOS = 'Usuários',
  PERMISSOES = 'Permissões',
  DASHBOARD_PROPOSTAS = 'Dashboards Propostas',
  IMPORTACOES = 'Importações',
}
